<template>

    <div class="row">
        <div class="col-lg-12">

            <div class="row">
                <div class="col">

                    <div class="form-group">

                        <!--<label>Contacts</label>-->
                        <vue-bootstrap4-table :rows="contactlist.contacts" :columns="dt.columns" :config="dt.config" :classes="dt.classes"
                                              :actions="dt.actions" @on-download="download">
                            <template slot="sort-asc-icon">
                                <i class="fas fa-sort-up"></i>
                            </template>
                            <template slot="sort-desc-icon">
                                <i class="fas fa-sort-down"></i>
                            </template>
                            <template slot="no-sort-icon">
                                <i class="fas fa-sort text-gray-200"></i>
                            </template>
                        </vue-bootstrap4-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import VueBootstrap4Table from 'vue-bootstrap4-table'
    var moment = require('moment')
    moment().format()

    export default {
        name: 'ContactListShow',
        data() {
            return {
                contactlist: {
                    hashid: null,
                    name: null,
                    contacts: [],
                },
                dt: {
                    classes: {
                        table: {
                            "table-striped": true,
                        }
                    },
                    columns: [
                        {
                            label: "Name",
                            name: "name",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                        {
                            label: "Email",
                            name: "email",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                            //slot_name: "action"
                        },
                        {
                            label: "Company Name",
                            name: "company",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                        {
                            label: "Job Title",
                            name: "job_title",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                        {
                            label: "Tel",
                            name: "tel",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                    ],
                    config: {
                        card_mode: false,
                        show_refresh_button: false,
                        show_reset_button: false,
                        per_page: 50,
                        per_page_options:  [50,  100,  200,  500],
                    },
                    actions: [
                        {
                            btn_text: "Download CSV",
                            event_name: "on-download",
                            class: "btn btn-outline-primary",
                            event_payload: {
                                //msg: "my custom msg"
                            }
                        }
                    ],
                },
            }
        },
        computed: {
        },
        components: {
            VueBootstrap4Table
        },
        props: {
            hashid: {
                type: String,
                // Object or array defaults must be returned from
                // a factory function
            },
        },
        methods: {

            moment(date) {
                return moment(date)
            },
            download() {
                var arraydata = []
                arraydata = this.contactlist.contacts
                arraydata = arraydata.map(function(data){
                    return _.pick(data, ['name', 'company', 'job_title', 'email', 'tel'])
                })

                let csvContent = "data:text/csv;charset=utf-8,"
                csvContent += [
                    Object.keys(arraydata[0]).join(","),
                    ...arraydata.map(item => Object.values(item).join(","))
                ]
                    .join("\n")
                    .replace(/(^\[)|(\]$)/gm, "")

                const data = encodeURI(csvContent)
                const link = document.createElement("a")
                link.setAttribute("href", data)
                link.setAttribute("download", "contacts.csv")
                link.click()
            },
        },
        mounted() {
            axios.get('/api/contactlist/'+this.hashid).then((response) => {
                this.contactlist = response.data.contactlist
            }).catch((error) => {
                Swal.fire({
                    title: 'Error',
                    text: 'Unable to retrieve record',
                    icon: 'error',
                    confirmButtonText: 'Dismiss'
                }).then((result) => {
                    location.href='/contactlist'
                });
            });
        }
    }
</script>

<style scoped>

</style>
